import { Component } from '@angular/core';
import { AuthService } from 'app/core/security/auth.service';

@Component({
  selector: 'profile',
  template: '<h3>Profile page</h3>Lorem Ipsum'
})
export class ProfileComponent {

  constructor(public authService:AuthService) { 
  }

}


// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/randonneurs-2018-build-and-to-local/src/app/core/profile/profile.component.ts